export default __webpack_public_path__ + "graphics/barrons.1479046e.svg";